import React, { useEffect } from 'react';
import Logo from '../components/Logo';
import VisionShowcase from '../components/VisionShowcase';

const CHECKLIST = [
  { label: 'Entity' },
  { label: 'DTO' },
  { label: 'Repository' },
  { label: 'Service' },
  { label: 'Controller' },
  { label: 'REST endpoints' },
  { label: 'Security + JWT' },
  { label: 'Swagger / OpenAPI' },
  { label: 'PostgreSQL config' },
  { label: 'Docker Compose' },
  { label: 'Postman collection' },
  { label: 'README.md' },
];

function CheckIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 8l3.5 3.5L13 5" />
    </svg>
  );
}

export default function PosterPage() {
  useEffect(() => {
    document.title = 'Backora — Design database. Generate backend.';
  }, []);

  return (
    <div className="poster-page">
      <div className="poster-blob poster-blob-1" aria-hidden="true" />
      <div className="poster-blob poster-blob-2" aria-hidden="true" />

      <header className="poster-header">
        <Logo size={32} />
      </header>

      <h1 className="poster-title-row">
        Design your database.{' '}
        <span className="poster-title-accent">Generate full backend.</span>
      </h1>

      <main className="poster-main-v3">
        <div className="poster-showcase-col">
          <VisionShowcase
            variant="stacked"
            kitePath="M 48 20 C 68 42, 42 62, 58 74"
            kiteArrowPath="M 55 73 L 58 74 L 57 71"
            kiteStrokeWidth={1}
            kiteDashArray=""
            schemaRelations={[
              { d: 'M 25 42 Q 30 52, 44 58' },
              { d: 'M 75 42 Q 70 52, 56 58' },
            ]}
            schemaRelationDashArray=""
            schemaRelationStrokeWidth={0.7}
          />
          <div className="poster-click-badge">
            <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
              <path d="M9 1L3 9h4l-1 6 7-9H9l1-5z" />
            </svg>
            <span>1 click</span>
          </div>
        </div>

        <div className="poster-right-col">
          <div className="poster-checklist">
            <div className="poster-checklist-title">
              <span>What you get</span>
            </div>
            <ul className="poster-checklist-items">
              {CHECKLIST.map((item) => (
                <li key={item.label} className="poster-check-item">
                  <span className="poster-check-box">
                    <CheckIcon />
                  </span>
                  <span className="poster-check-label">{item.label}</span>
                </li>
              ))}
            </ul>
          </div>

          <span className="poster-footer-cta">
            <span className="poster-footer-try">Try it</span>
            <span className="poster-footer-hand" aria-hidden="true">&#128073;</span>
            <span className="poster-footer-domain">backora.dev</span>
          </span>
        </div>
      </main>
    </div>
  );
}
